import { DOCUMENT, Injectable, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

const OVERLAY_STYLES: string = [
	'position: fixed',
	'inset: 0',
	'width: 100%',
	'height: 100%',
	'border: 0',
	'z-index: 2147483647',
	'background: #fff'
].join(';');

@Injectable({ providedIn: 'root' })
export class MaintenanceOverlayService {

	private readonly document = inject(DOCUMENT);
	private readonly html = signal<string | null>(null);

	show(error: HttpErrorResponse): void {
		if (this.html()) {
			return;
		}

		const body: unknown = error.error;
		if (typeof body === 'string' && body.trim()) {
			this.attach(body);
			return;
		}

		if (body instanceof Blob) {
			body.text().then((text: string) => {
				if (text && !this.html()) {
					this.attach(text);
				}
			});
		}
	}

	private attach(html: string): void {
		this.html.set(html);

		const iframe: HTMLIFrameElement = this.document.createElement('iframe');
		iframe.title = 'Service maintenance';
		iframe.srcdoc = html;
		iframe.style.cssText = OVERLAY_STYLES;
		this.document.body.appendChild(iframe);
		this.document.body.style.overflow = 'hidden';
	}
}
